module.exports = "<h1>{{diag.time}}</h1>"


//////////////////
// WEBPACK FOOTER
// ./src/components/current-time/current-time.html
// module id = 276
// module chunks = 0